export default {
	tenant: process.env.REACT_APP_TENANT_ID,
	clientId: process.env.REACT_APP_CLIENT_ID,
	scope: process.env.REACT_APP_SCOPE,
	apimKey: process.env.REACT_APP_APIM_KEY,
	datedFlightBaseUrl: process.env.REACT_APP_DATED_FLIGHT_BASE_URL,
	outageStart: process.env.REACT_APP_OUTAGE_START,
	outageEnd: process.env.REACT_APP_OUTAGE_END
}